// extracted by mini-css-extract-plugin
module.exports = {"kidsAccountNavWrapper":"zL","hidden":"zM","menuBackground":"zN","avatar":"zO","header":"zP","accountNavAvatar":"zQ","buttonPlaceholder":"zR","accountLinks":"zS","accountLink":"zT"};